import { createQueryKeyStore } from '@lukemorales/query-key-factory'
import { useQuery } from '@tanstack/react-query'
import * as _ from 'lodash-es'

import { graphql_call } from '@repo/common/queries/schemas/server_user_query'

import { query_list_crypto_contracts } from './crypto_contracts_graphql'

export const keys = createQueryKeyStore({
  crypto_contracts: {
    all: null,
    reward_wallets: null,
  },
})

export function useListCryptoContracts() {
  return useQuery({
    queryKey: keys.crypto_contracts.all.queryKey,
    queryFn: async () => {
      const results = await graphql_call({ query: query_list_crypto_contracts })
      return {
        contracts: results.contracts,
        contract_base_url: _.trimEnd(results.contract_base_url, '/'),
      }
    },
    staleTime: Infinity,
    gcTime: Infinity,
  })
}

export type CryptoContractNames =
  | 'DEX'
  | 'DEX_POSITION_MANAGER'
  | 'FISSION_POSITION_MANAGER'
  | 'QUOTERV2'
  | 'PERMIT2'
  | 'UNIVERSAL_ROUTER'

export function useGetContractAddress(name: CryptoContractNames) {
  const { data } = useListCryptoContracts()

  if (!data) return undefined

  return data.contracts.find((f) => f.name.toLowerCase() == name.toLowerCase())
    ?.address
}
